let consoleLogger = null;
let bureaucrat = null;
export const initializeBureaucratLogReporter = (
  bureaucratIn,
  consoleLoggerIn,
) => {
  bureaucrat = bureaucratIn;
  consoleLogger = consoleLoggerIn;
};

const defaults = {
  label: 'NO-LABEL',
  deployment: 'NO-DEPLOYMENT',
  service: 'NO-SERVICE',
};
class BureaucratLogReporter {
  constructor(metadata) {
    this.metadata = { ...defaults, ...metadata };
  }

  log(logObj) {
    // console.log('blogger', logObj);
    const msg = logObj.args.reduce(
      (previousValue, currentValue) =>
        `${previousValue}\n${
          typeof currentValue === 'object'
            ? JSON.stringify(currentValue, null, 2)
            : currentValue
        }`,
    );
    const payload = {
      ...this.metadata,
      message: msg,
      level: logObj.type,
      timestamp: logObj.date.toISOString(),
    };

    // don't send logs while unit testing
    if (bureaucrat && process.env.NODE_ENV !== 'test') {
      bureaucrat.sendLogs(payload).catch((error) => consoleLogger.debug(error));
    }
  }
}

export default BureaucratLogReporter;
